module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box info-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-sm table-bordered table-striped table-hover"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.rows.data), function(row, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), (row.user) ? _c('td', [_vm._v(_vm._s(row.user.name))]) : _vm._e(), _vm._v(" "), (row.user) ? _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.user.code))]) : _vm._e(), _vm._v(" "), (row.user) ? _c('td', [_vm._v(_vm._s(row.user.mobile))]) : _vm._e(), _vm._v(" "), (row.user) ? _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.address))]) : _vm._e()])
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Recent Members")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Sr. No.")]), _vm._v(" "), _c('th', [_vm._v("Cust Name")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Cust Code")]), _vm._v(" "), _c('th', [_vm._v("Mobile")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Address")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-265e261f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dashboard/recentmember.vue
// module id = 810
// module chunks = 0